var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6343_22849)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#C2FAE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05 14V6.944H9.45V14H8.05ZM8.764 5.614C8.49333 5.614 8.26933 5.53 8.092 5.362C7.924 5.194 7.84 4.97933 7.84 4.718C7.84 4.466 7.924 4.26067 8.092 4.102C8.26933 3.934 8.49333 3.85 8.764 3.85C9.02533 3.85 9.24467 3.934 9.422 4.102C9.59933 4.26067 9.688 4.466 9.688 4.718C9.688 4.97933 9.59933 5.194 9.422 5.362C9.24467 5.53 9.02533 5.614 8.764 5.614Z",
    fill: "#1F243B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.85,
    y: 0.85,
    width: 16.3,
    height: 16.3,
    rx: 8.15,
    stroke: "#1F243B",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6343_22849"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.f88d605c6c774ba9a6c3ffc9b93b1c8b.svg";
export { ForwardRef as ReactComponent };